import React from "react";
import { motion } from "framer-motion";
import { MapPin } from "lucide-react";

const WhereWeBuy = () => (
  <section
    id="where-we-buy"
    className="relative"
    style={{
      background: "#122B20",
      color: "#FAF7F2",
      paddingTop: "clamp(3.5rem, 7vw, 5.5rem)",
      paddingBottom: "clamp(3.5rem, 7vw, 5.5rem)",
    }}
    data-testid="where-we-buy-section"
  >
    <div className="max-w-4xl mx-auto px-6 md:px-10 text-center">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.35 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        className="mx-auto"
      >
        <div className="flex items-center justify-center gap-2">
          <MapPin size={16} color="#C6A15B" strokeWidth={1.75} />
          <p className="eyebrow">Where We Buy</p>
        </div>
        <h2
          className="font-heading font-medium mt-4"
          style={{
            fontSize: "clamp(2rem, 4vw, 3.2rem)",
            lineHeight: 1.12,
            color: "#FAF7F2",
            letterSpacing: "-0.015em",
          }}
        >
          Nationwide Reach.{" "}
          <span className="gold-italic">Colorado Roots.</span>
        </h2>
        <p
          className="mt-6 font-body mx-auto"
          style={{
            color: "rgba(250,247,242,0.88)",
            fontSize: "1.05rem",
            lineHeight: 1.8,
            maxWidth: "62ch",
          }}
        >
          We buy houses and land across the U.S., with deep, on-the-ground
          expertise in Denver and the greater Colorado market. Wherever your
          property is, if you’re ready to sell, we’re ready to talk.
        </p>
        <div
          className="mx-auto mt-8 h-px"
          style={{
            width: "72px",
            background:
              "linear-gradient(90deg, rgba(198,161,91,0) 0%, rgba(198,161,91,0.8) 50%, rgba(198,161,91,0) 100%)",
          }}
        />
      </motion.div>
    </div>
  </section>
);

export default WhereWeBuy;
